import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-arrow',
    templateUrl: './svg.arrow.component.html',
    styleUrls: ['./svg.arrow.component.scss'],
    standalone: false
})
export class SvgArrowComponent {
}
